import React, { createContext, useContext, useState } from 'react';

/**
 * DOIS sinais que uma página manda às molduras, e eles não são o mesmo:
 *
 * `fullscreenOverlay` — a página quer a área de conteúdo SEM o cartão branco (e, no aplicativo,
 *   sem a barra nativa do topo). O cabeçalho do portal e a barra lateral FICAM. É o do leitor de
 *   cartões e o da montagem.
 *
 * `telaCheia` — a página toma a JANELA INTEIRA: somem o cabeçalho, o rodapé e a barra lateral, e
 *   a altura fica presa à da janela, para que o que rola seja a lista da página, e não a página.
 *   É só o da montagem de simulado (10/10/2026), que desenha a própria barra fina com "voltar".
 *   Quem o respeita: `MainLayout`, `TeacherLayout` e `GestaoLayout`.
 *
 * São dois porque o leitor de cartões liga o primeiro e precisa do cabeçalho: fundi-los tiraria
 * dele o caminho de volta.
 */
interface FullscreenOverlayContextValue {
  fullscreenOverlay: boolean;
  setFullscreenOverlay: (v: boolean) => void;
  telaCheia: boolean;
  setTelaCheia: (v: boolean) => void;
}

const FullscreenOverlayContext = createContext<FullscreenOverlayContextValue>({
  fullscreenOverlay: false,
  setFullscreenOverlay: () => {},
  telaCheia: false,
  setTelaCheia: () => {},
});

export function FullscreenOverlayProvider({ children }: { children: React.ReactNode }) {
  const [fullscreenOverlay, setFullscreenOverlay] = useState(false);
  const [telaCheia, setTelaCheia] = useState(false);
  return (
    <FullscreenOverlayContext.Provider value={{ fullscreenOverlay, setFullscreenOverlay, telaCheia, setTelaCheia }}>
      {children}
    </FullscreenOverlayContext.Provider>
  );
}

export function useFullscreenOverlay() {
  return useContext(FullscreenOverlayContext);
}
